import bioImg from "../assets/course-cards/biology.jpg";
import mathsImg from "../assets/course-cards/maths.jpg";
import chemistryImg from "../assets/course-cards/chemistry.jpg";
import physicsImg from "../assets/course-cards/physics.jpg";
import PRODUCTS from "../pages/SignUpPage/products";
import { CARD_IMAGES } from "../data/brandCatalogue.generated";

/** Pre-product school subjects that still have enrolments. */
const LEGACY_SUBJECT_CARD_IMAGES: Record<string, string> = {
  Maths: mathsImg,
  Mathematics: mathsImg,
  Biology: bioImg,
  Chemistry: chemistryImg,
  Physics: physicsImg,
};

const PRODUCT_CARD_IMAGES_BY_SUBJECT_NAME: Record<string, string> = {
  ...LEGACY_SUBJECT_CARD_IMAGES,
  ...Object.fromEntries(
    PRODUCTS.flatMap((product) => {
      const image = product.cardImage ? CARD_IMAGES[product.cardImage] : undefined;
      if (!image) return [];
      return [product.title, ...product.subjectNames].map((name) => [name, image]);
    }),
  ),
};

/** Resolve a dashboard/enrolment card image from subject and/or class names. */
export function getProductCardImage(...names: Array<string | undefined | null>): string | undefined {
  for (const name of names) {
    if (!name) continue;
    const trimmed = name.trim();
    const direct = PRODUCT_CARD_IMAGES_BY_SUBJECT_NAME[trimmed];
    if (direct) return direct;
  }
  return undefined;
}
